<template>
  <div class="coupon-issue-management">
    <el-card class="search-card">
      <div slot="header" class="clearfix">
        <span>优惠券发放记录</span>
        <el-button style="float: right;" type="primary" size="small" icon="el-icon-plus" @click="handleAdd">发放优惠券</el-button>
      </div>

      <el-table :data="tableData" border stripe v-loading="tableLoading" height="calc(100vh - 280px)">
        <el-table-column prop="id" label="ID" width="80" align="center"></el-table-column>
        <el-table-column prop="couponName" label="优惠券名称" min-width="150"></el-table-column>
        <el-table-column label="优惠券类型" width="110" align="center">
          <template slot-scope="scope">
            <el-tag :type="scope.row.couponType === 1 ? 'warning' : 'success'" size="small">
              {{ scope.row.couponType === 1 ? '满减券' : '折扣券' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="用户" min-width="150">
          <template slot-scope="scope">
            <div>{{ scope.row.nickname || scope.row.username || '—' }}</div>
            <div style="color:#909399;font-size:12px;">{{ scope.row.phone || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" align="center">
          <template slot-scope="scope">
            <el-tag :type="getStatusType(scope.row.status)" size="small">
              {{ getStatusName(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="receiveTime" label="领取时间" width="170"></el-table-column>
        <el-table-column prop="useTime" label="使用时间" width="170"></el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="170"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button type="text" size="small" @click="handleMarkUsed(scope.row)" v-if="scope.row.status === 0">标记已使用</el-button>
            <el-button type="text" size="small" @click="handleDelete(scope.row)" style="color: #F56C6C;">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :current-page="pagination.pageNum"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px; text-align: right;">
      </el-pagination>
    </el-card>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px" @close="handleDialogClose">
      <el-form :model="form" :rules="rules" ref="form" label-width="110px">
        <el-form-item label="优惠券" prop="couponId">
          <el-select v-model="form.couponId" placeholder="请选择优惠券" style="width: 100%;" filterable>
            <el-option
              v-for="c in couponOptions"
              :key="c.id"
              :label="formatCouponLabel(c)"
              :value="c.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户" prop="userId">
          <el-select
            v-model="form.userId"
            placeholder="请输入用户手机号或用户名搜索"
            style="width: 100%;"
            filterable
            remote
            :remote-method="searchUsers"
            :loading="userLoading"
            reserve-keyword
          >
            <el-option
              v-for="u in userOptions"
              :key="u.id"
              :label="`${u.nickname || u.username}（${u.phone || '无手机'}）`"
              :value="u.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="form.status" placeholder="请选择" style="width: 100%;">
            <el-option label="未使用" :value="0"></el-option>
            <el-option label="已使用" :value="1"></el-option>
            <el-option label="已过期" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="领取时间" prop="receiveTime">
          <el-date-picker
            v-model="form.receiveTime"
            type="datetime"
            placeholder="选择领取时间"
            value-format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCouponIssueList, addCouponIssue, updateCouponIssue, deleteCouponIssue, getCouponList, getUserList } from '@/api'

export default {
  name: 'CouponIssueManagement',
  data() {
    return {
      tableData: [],
      tableLoading: false,
      dialogVisible: false,
      dialogTitle: '',
      submitLoading: false,
      pagination: {
        pageNum: 1,
        pageSize: 10,
        total: 0
      },
      couponOptions: [],
      userOptions: [],
      userLoading: false,
      form: {
        id: null,
        couponId: null,
        userId: null,
        status: 0,
        receiveTime: null
      },
      rules: {
        couponId: [{ required: true, message: '请选择优惠券', trigger: 'change' }],
        userId: [{ required: true, message: '请选择用户', trigger: 'change' }],
        status: [{ required: true, message: '请选择状态', trigger: 'change' }]
      }
    }
  },
  created() {
    this.loadCoupons()
    this.loadData()
  },
  methods: {
    async loadCoupons() {
      try {
        const res = await getCouponList()
        this.couponOptions = (res.data || []).filter(c => c.status === 1)
      } catch (e) {
        console.error(e)
      }
    },

    async loadData() {
      this.tableLoading = true
      try {
        const res = await getCouponIssueList({
          pageNum: this.pagination.pageNum,
          pageSize: this.pagination.pageSize
        })
        this.tableData = res.data?.list || res.data?.records || []
        this.pagination.total = res.data?.total || 0
      } catch (e) {
        this.$message.error('加载数据失败')
      } finally {
        this.tableLoading = false
      }
    },

    handlePageChange(page) {
      this.pagination.pageNum = page
      this.loadData()
    },

    handleSizeChange(size) {
      this.pagination.pageSize = size
      this.pagination.pageNum = 1
      this.loadData()
    },

    async searchUsers(query) {
      if (!query || query.length < 2) {
        this.userOptions = []
        return
      }
      this.userLoading = true
      try {
        const res = await getUserList({ pageNum: 1, pageSize: 20, phone: query })
        this.userOptions = res.data.list || []
      } catch (e) {
        console.error(e)
      } finally {
        this.userLoading = false
      }
    },

    handleAdd() {
      this.dialogTitle = '发放优惠券'
      this.resetForm()
      this.dialogVisible = true
    },

    handleEdit(row) {
      this.dialogTitle = '编辑发放记录'
      this.userOptions = [{
        id: row.userId,
        username: row.username,
        nickname: row.nickname,
        phone: row.phone
      }]
      this.form = {
        id: row.id,
        couponId: row.couponId,
        userId: row.userId,
        status: row.status,
        receiveTime: row.receiveTime
      }
      this.dialogVisible = true
    },

    handleDialogClose() {
      this.$refs.form && this.$refs.form.resetFields()
      this.userOptions = []
      this.resetForm()
    },

    resetForm() {
      this.form = {
        id: null,
        couponId: null,
        userId: null,
        status: 0,
        receiveTime: null
      }
    },

    handleSubmit() {
      this.$refs.form.validate(async (valid) => {
        if (!valid) return
        this.submitLoading = true
        try {
          const data = { ...this.form }
          if (this.form.id) {
            await updateCouponIssue(this.form.id, data)
            this.$message.success('更新成功')
          } else {
            await addCouponIssue(data)
            this.$message.success('发放成功')
          }
          this.dialogVisible = false
          this.loadData()
        } catch (e) {
          // 错误已在拦截器处理
        } finally {
          this.submitLoading = false
        }
      })
    },

    handleMarkUsed(row) {
      this.$confirm(`确定要将「${row.couponName}」标记为已使用吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await updateCouponIssue(row.id, { status: 1 })
          this.$message.success('操作成功')
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    },

    handleDelete(row) {
      this.$confirm(`确定要删除该发放记录吗？`, '删除确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        try {
          await deleteCouponIssue(row.id)
          this.$message.success('删除成功')
          this.loadData()
        } catch (e) {}
      }).catch(() => {})
    },

    formatCouponLabel(c) {
      if (c.type === 1) {
        return `${c.name}（满${c.threshold || '无门槛'}减${c.discount}，剩余${c.remainStock}张）`
      }
      return `${c.name}（${(c.discount * 10).toFixed(1)}折，剩余${c.remainStock}张）`
    },

    getStatusType(status) {
      switch (status) {
        case 0: return 'success'
        case 1: return 'info'
        case 2: return 'danger'
        default: return 'info'
      }
    },

    getStatusName(status) {
      switch (status) {
        case 0: return '未使用'
        case 1: return '已使用'
        case 2: return '已过期'
        default: return '未知'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.coupon-issue-management {
  padding: 20px;
}
</style>
